var defaultLogger = {
  log: function log() {
    return;
  },
  warn: function warn() {
    return;
  },
  error: function error() {
    return;
  }
};
var logger = defaultLogger;
function getLogger() {
  return logger;
}
function setLogger(newLogger) {
  logger = newLogger;
}

export { getLogger, setLogger };
//# sourceMappingURL=logger.js.map
